<template>
  <Modal :y="50" :yTransform="50">
    <div class="flex justify-between">
      <div>
      </div>
      <div class="pl-2">
        <h1 class="text-2xl">Add Instruction URLs</h1>
      </div>
      <div @click="$emit('cancel')" class="clickable circular pl-4 pt-4">
        <CloseIcon />
      </div>
    </div>
    <div class="flex items-center justify-center pb-4">
      <Text size="md">
        The bolded variables have limited survey instructions. 
        To provide additional instructions on how to fill in TLFB quantities, enter a public link (e.g. using Box) to an instructional document.
      </Text>
    </div>
    <Table
      style="max-width: 800px"
      :headers="[
        'Order',
        { 
          header: 'Variable',
          center: false
        },
        'Mode / Unit',
        {
          header: 'Data Type',
          center: false
        },
        {
          header: 'Instruction URL',
          center: true,
          info: 'Include all components of a valid URL (https, .com, etc.)'
        }
      ]"
    >
      <TableRow
        v-for="(oss, rowIndex) in otlfbSurveySubstances"
        :key="oss.substanceId + '-' + oss.substanceModeId + '-otlfb-survey-substance-url-submission'"
        :class="{ maroon: true, bold: !hasPresetInstructions(oss, oss.substanceMode.dataType) }"
      >
        <Cell>
          <Text
            size="lg"
            class="pl-4"
            >
            {{ rowIndex + 1 }}
          </Text>
        </Cell>
        <Cell>
          {{ toUpperCase(oss.substance.name) }}
        </Cell>
        <Cell>
          {{ toUpperCase(oss.substanceMode.name) }}
        </Cell>
        <Cell>
          {{ toUpperCase(oss.substanceMode.dataType) }}
        </Cell>
        <Cell>
          <div class="w-60 flex items-center justify-center">
            <InputText
              v-if="!hasPresetInstructions(oss, oss.substanceMode.dataType)"
              v-model="instructionUrls[rowIndex]"
              size="lg"
              :maxlength=150
              :class="{ 
                error: !isUrlValid(instructionUrls[rowIndex]), 
                valid: isUrlValid(instructionUrls[rowIndex]) && instructionUrls[rowIndex] !== ''
              }"
             />
            <Text size='sm'  v-else italic>
              Instructions are built-in
            </Text>
          </div>
        </Cell>
      </TableRow>
    </Table>
    <div class="flex items-center pt-4 justify-center">
      <Button
        :disabled="!allUrlsValid"
        :showSpinner="saving"
        theme="secondary"
        size="lg"
        @click="submitUrlsAndSave"
      >
        Save URLs and Create Survey
      </Button>
    </div>
  </Modal>
</template>

<script setup>
import { ref, computed } from "vue"
import Table from "./Table.vue"
import TableRow from "./TableRow.vue"
import Cell from "./Cell.vue"
import Button from "./Button.vue"
import Text from "./Text.vue"
import Modal from "./Modal.vue"
import CloseIcon from "./CloseIcon.vue"
import InputText from "./InputText.vue"
import toUpperCase from "../utils/toUpperCase"
import hasPresetInstructions from "../utils/hasPresetInstructions"

const props = defineProps({
  otlfbSurveySubstances: {
    type: Array,
    required: true
  }
})

const emit = defineEmits('cancel', 'submit-urls')

const instructionUrls = ref(props.otlfbSurveySubstances.map(() => { return "" }))

function isUrlValid(url) {
  try {
    if (url === '') { return true }
    new URL(url)
    return true
  } catch (_) {
    return false
  }
}

const allUrlsValid = computed(() => {
  return instructionUrls.value.filter(url => isUrlValid(url)).length === instructionUrls.value.length
})

const saving = ref(false)
function submitUrlsAndSave() {
  saving.value = true
  emit('submit-urls', instructionUrls.value)
}

</script>

<style scoped>
.bold {
  font-weight: 550;
}

</style>
